import { Button, Text, Flex, Box, Container } from "@chakra-ui/react";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { LogoConnecteed } from "assets";

import { LOCAL_OR_STAGE } from "libs/auth";
import { useLogout } from "hooks";

const RedirectToUnifiedPage = () => {
    const { t } = useTranslation();


    const connecteedUrl = `https://${LOCAL_OR_STAGE === "production" ? "" : `${LOCAL_OR_STAGE}.`}partner.connecteed.freelance.com`;
    const { logout } = useLogout();


    return (
        <Container maxW="1200px" py={16}  >

            <Flex justify="flex-end" mb={4}>
                <Button variant={"outline"} onClick={() => logout()}>Déconnexion</Button>
            </Flex>
            <Flex flexDirection="row" gap={16}>
                <Flex flex={1} align="center" justify="center" >
                    <Box maxW="480px">
                        <Text fontSize="2.5rem" fontWeight={700} color="brand.blue.main" mb={4} lineHeight={1.1}>
                            {t(
                                "discover_new_portal",
                                "Découvrez le nouveau portail Connecteed !"
                            )}
                        </Text>
                        <Text fontSize="md" color="gray.600" mb={8} fontWeight={400}>
                            {t(
                                "portal_subtext",
                                "Profitez d'une expérience améliorée pour le dépôt de vos CRA, PV et factures et la gestion de vos prestations portées par les entités du groupe Freelance.com."
                            )}
                        </Text>
                        <Button
                            as={NavLink}
                            to={connecteedUrl}
                            bg="brand.blue.main"
                            color="white"
                            _hover={{ bg: "brand.blue.dark" }}
                            size="lg"
                            fontWeight={700}
                            borderRadius="xl"
                            px={8}
                            py={6}
                            fontSize="lg"
                        >
                            {t("access_new_portal", "Accéder au nouveau portail")}
                        </Button>
                    </Box>
                </Flex >
                <Flex flex={1} align="center" justify="center">

                    <LogoConnecteed width="500px" height="500px" />

                </Flex>
            </Flex>
        </Container >
    );
};

export default RedirectToUnifiedPage;
